import React from 'react'

import { connect } from 'react-redux'
import {
  toggleOpcionesGuardadas,
  getConfiguracionesGuardadas,
  getConfiguracionesSave,
  recuperarConfiguracion,
  setConfiguraciones,
  resetToken,
  getTextoMiPerfil,
  getTextoConfiguraciones,
  getTextoCerrarSesion,
  getTextoGuardar,
  getTextoMaximoConfiguraciones,
  getTextoConfiguracion,
  getTextoRecuperar,
  getTextoEliminar
} from '../../modules/reducer'

import { MdClear } from 'react-icons/md'
import { IconContext } from 'react-icons'

import Tree from '../MenuEstancias/Tree'
import { eliminarConfiguracion, salvarConfiguracion } from '../drupal'

import { gaEvent } from '../../Cookies'

const gaEventConfiguracion = estancias => {
  estancias.forEach(estancia => {
    estancia.acabados.forEach(acabado => {
      acabado.opciones.forEach(opcion => {
        gaEvent({
          category: 'Opción guardada',
          action: `${estancia.gaTitle} ${acabado.gaTitle}`,
          label: opcion.gaTitle
        })
      })
    })
  })
}

const OpcionesGuardadas = ({
  open,
  toggleOpcionesGuardadas,
  configuraciones,
  configuracionesSave,
  recuperarConfiguracion,
  history,
  idUsuario,
  setConfiguraciones,
  resetToken,
  srcLogo,
  textoMiPerfil,
  textoConfiguraciones,
  textoCerrarSesion,
  textoGuardar,
  textoMaximoConfiguraciones,
  textoConfiguracion,
  textoRecuperar,
  textoEliminar
}) => {
  return (
    <div className="resumen" style={{ display: open ? 'block' : 'none' }}>
      <section className="modal-main">
        <div className="close-resumen" onClick={e => toggleOpcionesGuardadas()}>
          <IconContext.Provider
            value={{
              color: '#434343',
              size: '2em'
            }}
          >
            <MdClear />
          </IconContext.Provider>
        </div>
        <div className="container-resumen grid-center-noGutter">
          <Tree
            className="col-10 grid-noGutter-spaceBetween"
            name={textoMiPerfil}
            padding={0}
            open={false}
            style={{ fontSize: '1.5em', textTransform: 'capitalize' }}
            styleIcon={{ marginTop: 10 }}
          >
            <div
              className="button"
              style={{ backgroundColor: '#f07204' }}
              onClick={e => resetToken()}
            >
              {textoCerrarSesion}
            </div>
          </Tree>
          <div
            className="col-10 grid-noGutter-spaceBetween"
            style={{
              margin: '10px 0',
              width: '100%',
              border: '1px solid #cdcdcd'
            }}
          />
          <Tree
            className="col-10 grid-noGutter-spaceBetween"
            name={textoConfiguraciones}
            padding={0}
            open={false}
            style={{ fontSize: '1.5em', textTransform: 'capitalize' }}
            styleIcon={{ marginTop: 10 }}
          >
            <div
              className="col-10 grid-noGutter-spaceBetween"
              style={{ paddingBottom: 10 }}
            >
              {configuraciones.length < 3 ? (
                <div
                  className="button"
                  style={{ backgroundColor: '#f07204' }}
                  onClick={e => {
                    gaEventConfiguracion(configuracionesSave)

                    const configuracionesSave1 = configuracionesSave.map(
                      estancia => {
                        const acabados = estancia.acabados.map(acabado => {
                          const opciones = acabado.opciones.map(
                            opcion => opcion.id
                          )

                          return {
                            id: acabado.id,
                            opciones
                          }
                        })

                        return {
                          id: estancia.id,
                          acabados
                        }
                      }
                    )

                    salvarConfiguracion(
                      idUsuario,
                      configuracionesSave1,
                      configuraciones,
                      setConfiguraciones
                    )
                  }}
                >
                  {textoGuardar}
                </div>
              ) : (
                <div>{textoMaximoConfiguraciones}</div>
              )}
            </div>

            {configuraciones.map((configuracion, index) => (
              <Tree
                key={configuracion.id}
                className="col-10"
                name={`${textoConfiguracion} ${index + 1}`}
                padding={0}
                open={false}
              >
                <div className="col-10" style={{ paddingBottom: 20 }}>
                  <div className="grid-noGutter-right">
                    <div
                      className="button"
                      style={{
                        backgroundColor: '#f07204',
                        margin: '0 10px'
                      }}
                      onClick={e => {
                        recuperarConfiguracion(configuracion.id)
                      }}
                    >
                      {textoRecuperar}
                    </div>
                    <div
                      className="button"
                      style={{
                        backgroundColor: '#f07204',
                        margin: '0 10px'
                      }}
                      onClick={e => {
                        eliminarConfiguracion(
                          idUsuario,
                          configuracion.id,
                          configuraciones,
                          setConfiguraciones
                        )
                      }}
                    >
                      {textoEliminar}
                    </div>
                  </div>
                </div>
                {configuracion.estancias.map(estancia => (
                  <>
                    <h1 style={{ margin: 0, padding: 0 }}>{estancia.title}</h1>
                    {estancia.acabados.map(acabado =>
                      acabado.opciones.map(opcion => (
                        <div
                          key={`${configuracion.id}_${estancia.id}_${
                            acabado.id
                          }_${opcion.id}`}
                          className="row-container-resumen col-10_sm-12 grid-middle-noGutter"
                          style={{
                            position: 'relative'
                          }}
                        >
                          <div className="row-icono-container-resumen">
                            <img
                              className="row-icono-resumen"
                              src={opcion.srcIcono}
                              alt=""
                            />
                          </div>
                          <div className="row-texto-container-resumen">
                            <div className="title-resumen">{opcion.title}</div>
                            <div className="subtitle-resumen">
                              {opcion.subtitle}
                            </div>
                            <div>{`${opcion.precio}€`}</div>
                          </div>
                        </div>
                      ))
                    )}
                  </>
                ))}
              </Tree>
            ))}
          </Tree>
          <div
            className="col-10 grid-noGutter-spaceBetween"
            style={{
              width: '100%',
              padding: '10px 0',
              borderTop: '2px solid #cdcdcd',
              marginTop: 50
            }}
          >
            <div className="col-3_sm-2" />
            <img style={{ height: 115, width: 303 }} src={srcLogo} alt="" />
            <div className="col-3_sm-2" />
          </div>
        </div>
      </section>
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    open: reducer.openOpcionesGuardadas,
    configuraciones: getConfiguracionesGuardadas(reducer),
    idUsuario: reducer.idUsuario,
    configuracionesSave: getConfiguracionesSave(reducer),
    srcLogo: reducer.srcLogoConfiguraciones,
    textoMiPerfil: getTextoMiPerfil(reducer),
    textoConfiguraciones: getTextoConfiguraciones(reducer),
    textoCerrarSesion: getTextoCerrarSesion(reducer),
    textoGuardar: getTextoGuardar(reducer),
    textoMaximoConfiguraciones: getTextoMaximoConfiguraciones(reducer),
    textoConfiguracion: getTextoConfiguracion(reducer),
    textoRecuperar: getTextoRecuperar(reducer),
    textoEliminar: getTextoEliminar(reducer)
  }
}

const mapDispatchToProps = {
  toggleOpcionesGuardadas,
  recuperarConfiguracion,
  setConfiguraciones,
  resetToken
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpcionesGuardadas)
